module.exports = __webpack_public_path__ + "img/40_38_037_840.cbb32834.jpg";